import { render, staticRenderFns } from "./return_list.vue?vue&type=template&id=7d1ae15c&scoped=true"
import script from "./return_list.vue?vue&type=script&lang=js"
export * from "./return_list.vue?vue&type=script&lang=js"
import style0 from "./return_list.vue?vue&type=style&index=0&id=7d1ae15c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ae15c",
  null
  
)

export default component.exports